
import React from 'react';
import PageHeader from '../layouts/PageHeader';
import Heading from '../layouts/Heading';
import Text from '../layouts/Text';
import SectionComposition from '../layouts/SectionComposition';
import { Tabs, Tab, Row } from 'react-bootstrap';
import PageTitle from '../hooks/PageTitle';

const About = () => {

  return (
    <>
      <PageTitle title="About" />

      <PageHeader headerTitle="About" />

      <SectionComposition bgColor="off-white">
        <div className="container-xxl">
          <div className="container">

            <Heading headingTitle="About Me" />

            <Tabs defaultActiveKey="about" className="mb-3">

              {/* =========================
                  ABOUT ME
              ========================= */}
              <Tab eventKey="about" title="ABOUT ME">

                <div data-aos="fade-up">
                  <Text
                    text="I am Md. Milton Hossain, a Software Engineer and Web Application Developer with professional experience in designing, developing, deploying, and maintaining web-based applications. I have been working in web application development since 2019, with a strong focus on building scalable, secure, and user-friendly enterprise solutions."
                  />

                  <Text
                    text="I completed my Master of Information Technology (MIT) from the Department of Information Technology at Jahangirnagar University. My core expertise includes PHP, Laravel, React JS, JavaScript, MySQL, REST API development, database design, Linux server management, and web application deployment."
                  />

                  <Text
                    text="Currently, I am working at Khwaja Yunus Ali University, where I contribute to the development and maintenance of software solutions that support organizational and institutional operations."
                  />

                  <h1
                    className="display-6 py-3"
                    data-aos="fade-up"
                  >
                    I design and develop web applications and enterprise
                    software solutions since 2019.
                  </h1>
                </div>

              </Tab>


              {/* =========================
                  CAREER OBJECTIVE
              ========================= */}
              <Tab eventKey="objective" title="CAREER OBJECTIVE">

                <div data-aos="fade-up">

                  <h3 className="display-6">
                    Career Objective
                  </h3>

                  <Text
                    text="To build a successful career as a Software Engineer and Enterprise Solution Developer by designing and developing secure, scalable, maintainable, and high-performance software solutions that solve real-world business and organizational challenges."
                  />

                  <Text
                    text="I aim to continuously improve my technical and architectural skills while contributing to innovative software projects, enterprise applications, system integration, and digital transformation initiatives."
                  />

                </div>

              </Tab>


              {/* =========================
                  CAREER SUMMARY
              ========================= */}
              <Tab eventKey="summary" title="CAREER SUMMARY">

                <div data-aos="fade-up">

                  <h3 className="display-6">
                    Career Summary
                  </h3>

                  <Text
                    text="A results-oriented Software Engineer and Web Application Developer with professional experience since 2019 in developing and maintaining enterprise web applications and information management systems."
                  />

                  <Text
                    text="My experience covers the complete software development lifecycle, including requirements analysis, system architecture, database design, backend development, frontend development, REST API development, third-party API integration, authentication and authorization, server configuration, deployment, troubleshooting, and system maintenance."
                  />

                  <Text
                    text="I have hands-on experience with Laravel, PHP, React JS, JavaScript, MySQL, Bootstrap, REST APIs, Linux VPS, Nginx, Apache, aaPanel, cPanel, Cloudflare, and domain and hosting management."
                  />

                  <Text
                    text="I focus on developing reliable, maintainable, and scalable software solutions that can support complex business processes, institutional operations, and enterprise-level requirements."
                  />

                </div>

              </Tab>


          


            </Tabs>

          </div>
        </div>
      </SectionComposition>
    </>
  );
};

export default About;

